import ApiJobFavourite from 'types/api/JobFavourite';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import JobFavourite from 'models/JobFavourite';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {}
export const list = async (params?: ListParams): Promise<ListCollection<JobFavourite>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.WorkerJobFavourites, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.JobFavourites];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiJobFavourite) => new JobFavourite(element)),
        meta: resource.meta,
    };
};

export interface CreateParams {
    jobId: string;
    cityId: string;
}
export const create = async (params?: CreateParams): Promise<any> => {
    await request({
        method: 'POST',
        path: withVariables(Endpoints.WorkerJobFavourites, params),
        requestParams: params,
    });
};
export interface RemoveParams {
    id: string;
}
export const remove = async (params: RemoveParams): Promise<any> => {
    await  request({
        method: 'DELETE',
        path: withVariables(Endpoints.RemoveWorkerJobFavourites, params),
        requestParams: params,
    })
        .catch(error => {
            console.error(error);
            throw error;
        });
};
